import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { podImageUrl } from "../../lib/utils";

export function PodViewerDialog({ open, onOpenChange, delivery }) {
  if (!delivery) return null;
  const images = [delivery.pof1, delivery.pof2].filter(Boolean);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="pod-viewer-dialog">
        <DialogHeader>
          <DialogTitle>Proof of Delivery — #{delivery.id}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4">
          {images.map((filename) => (
            <div key={filename} className="aspect-[3/4] w-full overflow-hidden rounded-md border border-border bg-background">
              <img
                src={podImageUrl(filename)}
                alt="Proof of delivery"
                className="h-full w-full object-contain"
                data-testid="pod-viewer-image"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
              <div className="hidden h-full w-full items-center justify-center text-xs text-text-muted" data-testid="pod-viewer-image-fallback">
                Image not available
              </div>
            </div>
          ))}
          {images.length === 0 && (
            <p className="py-6 text-center text-sm text-text-muted">No proof of delivery on file.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
